import { render, staticRenderFns } from "./TeamMembers.vue?vue&type=template&id=a925bdc2&scoped=true&"
import script from "./TeamMembers.vue?vue&type=script&lang=js&"
export * from "./TeamMembers.vue?vue&type=script&lang=js&"
import style0 from "./TeamMembers.vue?vue&type=style&index=0&id=a925bdc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a925bdc2",
  null
  
)

export default component.exports